import { useContext } from 'react'

import { TokenHelperContext } from './components'

const useTokenHelper = () => useContext(TokenHelperContext)

export {
  useTokenHelper
}
